import { ScoreTopic } from '@/types'
import { Tag } from '../Tag'
import { getTopicBackground } from '@/utils'
import { hexToCSSFilter } from 'hex-to-css-filter'

type TopicTagProps = {
    topic?: ScoreTopic
}

export const TopicTag = (props: TopicTagProps) => {
  const {
    topic,
  } = props

  return <Tag
    debugName={'pulseQuestion:tag'}
    text={topic?.label}
    variants={['tiny']}
    styles={{
      wrapper: {
        backgroundColor: getTopicBackground(topic?.color),
      },
      text: {
        color: topic?.color,

      },
      leftIcon: {
        filter: topic?.color ? hexToCSSFilter(topic?.color).filter : 'initial',

      },
    }}

    leftIconProps={{
      source: topic?.icon,

    }}

  />
}
